/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, November 7th 2022, 3:04:33 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useForm } from "react-hook-form";
import InputIcon from "@mui/icons-material/Input";
import { getDefaultAjaxSourceParameter } from "lib/factories";
import { AjaxSource, AjaxSourceParameter, AjaxSourceParameterValidationSchema } from "lib/schemas";
import { ValidationResolver } from "lib/validation";
import {
  OSForm,
  RelatedObjectOSFormProps,
  TextFormInput,
  NestedOne2ManyPopupFormInput,
  Typography,
  ConcreteAPIRelatedFormPopupInputProps,
  IconText,
} from "ui-widgets";

const AjaxSourceParameterForm = (props: RelatedObjectOSFormProps<AjaxSourceParameter>) => {
  const { defaultItemValue } = props;

  const useFormReturn = useForm<any>({
    defaultValues: defaultItemValue,
    mode: "onTouched",
    resolver: ValidationResolver(AjaxSourceParameterValidationSchema),
  });

  return (
    <OSForm
      onFormSubmit={useFormReturn.handleSubmit(props.handleValidForm)}
      validationSchema={AjaxSourceParameterValidationSchema}
      useFormReturn={useFormReturn}
      onFormCancel={props.onFormCancel}
    >
      <TextFormInput<AjaxSourceParameter> schema_field_key="key" label="Key" />
      <TextFormInput<AjaxSourceParameter> schema_field_key="value" label="Value" />
    </OSForm>
  );
};

export const AjaxSourceParameterNestedPopUpField = ({
  ...props
}: ConcreteAPIRelatedFormPopupInputProps<AjaxSource, AjaxSourceParameter> & { ajaxSource: AjaxSource }) => {
  return (
    <NestedOne2ManyPopupFormInput<AjaxSource, AjaxSourceParameter>
      renderRelatedObjectForm={({ currentEditItem, handleClose, onChangeRelatedItem }) => (
        <AjaxSourceParameterForm
          defaultItemValue={currentEditItem ?? getDefaultAjaxSourceParameter(props.ajaxSource)}
          onFormCancel={handleClose}
          handleValidForm={onChangeRelatedItem}
        />
      )}
      popUpTitle={
        <Typography>
          <IconText
            icon={<InputIcon color="primary" />}
            textComponent={<Typography variant="h5">Source Input</Typography>}
          />
        </Typography>
      }
      itemIdProperty="id"
      getOptionLabel={(option) => `${option.key}=${option.value}`}
      schema_field_key={props.schema_field_key}
      label={props.label}
    />
  );
};
